import { NavController } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { TokenService } from 'src/app/servicios/token.service';

@Injectable({
  providedIn: 'root'
})
export class IngresadoGuard  {

  constructor(public navCtrl: NavController, private TS:TokenService){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(this.TS.hasValidToken()){
        this.navCtrl.navigateRoot('menu/home');
        return false;
      }else{
        return true;
      }
  }

}
